module.exports = __webpack_public_path__ + "static/tandemex-eda3c56ceb63dfce701b725853110a3c.jpg";